import { notification } from 'antd'
import { navigate } from 'gatsby'
import React, { useState } from 'react'
import { useStripeCustomerPortal } from "../../data/models/payments"

const BUTTON_LABEL = 'Billing'
const BUTTON_LABEL_LOADING = 'Loading...'
const BUTTON_LABEL_REDIRECTING = 'Redirecting...'

export function BillingButton() {
  const [label, setLabel] = useState(BUTTON_LABEL)

  // API
  const { isLoading, mutate: loadCustomerPortal } = useStripeCustomerPortal({
    onSuccess: (url) => {
      setLabel(BUTTON_LABEL_REDIRECTING)
      navigate(url)
    },
    onError: (error) => {
      notification.error({
        message: 'Error',
        description: 'Failed to load the billing portal.',
      })
    },
  })

  // Event handlers
  const handleClick = () => {
    if (!isLoading) {
      setLabel(BUTTON_LABEL_LOADING)
      loadCustomerPortal(document.location.href)
    }
  }

  return (
    <a onClick={handleClick}>
      {label}
    </a>
  )
}
